// extracted by mini-css-extract-plugin
export default {"vf-footer":"EBIFooter_styles__vf-footer___a1","vf-list__item":"EBIFooter_styles__vf-list__item___da"};